<!-- 图片上传组件 -->
<template>
  <el-upload ref="upload" :class="{ hide: fileList.length > 0 }" action="#" :file-list="fileList" :on-change="changeFile" :on-remove="removeFile" :auto-upload="false" accept=".png,.jpg,.jpeg,.gif" list-type="picture-card" :multiple="false" :limit="1" :disabled="disabled">
    <i class="el-icon-plus add-icon" v-show="!disabled"/>
  </el-upload>
</template>

<script>
export default {
  name: 'ImageUpload',
  props: {
    //图片地址
    url: { type: String },
    //宽度
    width: { type: String },
    //高度
    height: { type: String },
    //图片改变回调方法
    onChange: { type: Function },
    //传递的路径是否是完整预览路径
    isFull: { type: Boolean },
    //是否禁用
    disabled: { type: Boolean }
  },
  data() {
    return {
      //文件列表
      fileList: []
    }
  },
  methods: {
    //移除文件
    removeFile: function(){
      //文件列表清空
      this.fileList = []
      //回调处理
      this.updateData()
    },
    //文件改变
    changeFile: function(file, fileList){
      //记录当前的文件列表
      this.fileList = fileList
      //回调处理
      this.updateData()
    },
    //组件属性初始化操作
    initData: function(){
      //组件
      let dom = this.$refs.upload.$el
      //图片选择框
      let select = dom.getElementsByClassName('el-upload--picture-card')
      $(select).css({ width: this.width || '148px', height: this.height || '148px' })
      //加号图标居中
      let icon = dom.getElementsByClassName('add-icon')
      let css = { lineHeight: this.height || '148px' }
      if(this.height){
        let h = this.height.replace('px', '')
        if(h < 140) {
          css.top = ((h - 140) / 10 * 4) + 'px'
        }
      }
      $(icon).css(css)
      //图片加载
      this.loadImage()
    },
    //预览图像框大小设置
    setImageSize: function(){
      //图片预览组件
      let image = this.$refs.upload.$el.getElementsByClassName('el-upload-list__item')
      $(image).css({ width: this.width || '148px', height: this.height || '148px' })
    },
    //加载初始图片
    loadImage: function(){
      if(this.url){
        $(this.$refs.upload.$el.getElementsByClassName('el-upload-list__item')).remove()
        this.fileList = [{
          url: this.isFull ? this.url : this.$BASE_URL + this.url
        }]
        //图片加载失败
        this.$nextTick(() => {
          let images = this.$refs.upload.$el.getElementsByClassName('el-upload-list__item-thumbnail')
          if(images && images[0]){
            images[0].onerror = () => {
              $(images[0]).attr('src', require('@/assets/images/fail.svg'))
            }
          }
        })
      } else {
        this.fileList = []
      }
    },
    //图片改变回调更新数据
    updateData: function(){
      if(this.onChange){
        this.onChange(this.fileList[0])
      }
    }
  },
  watch: {
    fileList(newVal) {
      //当有图片时，重新设置预览图片大小
      if(newVal && newVal.length > 0){
        this.$nextTick(() => this.setImageSize())
      } else {
        //直接移除图片（解决动画延时导致页面错乱问题）
        $(this.$refs.upload.$el.getElementsByClassName('el-upload-list__item')).remove()
      }
    },
    url() {
      this.loadImage()
    }
  },
  mounted () {
    //组件属性初始化操作
    this.initData()
  }
}
</script>

<style scoped>
.hide /deep/ .el-upload--picture-card {
  display: none;
}
.add-icon {
  position: relative;
}
.add-icon:before {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/models/ImageUpload.vue